import { render, staticRenderFns } from "./StoryfinderCard.vue?vue&type=template&id=1cc4c914&scoped=true"
import script from "./StoryfinderCard.vue?vue&type=script&lang=js"
export * from "./StoryfinderCard.vue?vue&type=script&lang=js"
import style0 from "./StoryfinderCard.vue?vue&type=style&index=0&id=1cc4c914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc4c914",
  null
  
)

export default component.exports